module.exports = __webpack_public_path__ + "img/ITU-logo-EN.3596a996.png";